export const endpoints = {
  auth: {
    v1: {
      authLogin: 'v1/auth/login',
      authRefreshToken: 'v1/auth/refreshToken',
      authLogout: 'v1/auth/logout',
      authRegister: 'v1/auth/register',
      authSendApplicationInvite: 'v1/auth/sendApplicationInvite',
      authValidateEmail: 'v1/auth/validateEmail',
      authValidateGoogleLoginToken: 'v1/auth/validateGoogleLoginToken',
      authContinueWithGoogle: 'v1/auth/continueWithGoogle',
      authForgotPasswordPasswordReset: 'v1/forgotPassword/passwordReset',
      authForgotPasswordNewPassword: 'v1/forgotPassword/newPassword',
      authUsers: 'v1/users',
      forgotPasswordPasswordReset: 'v1/forgotPassword/passwordReset',
      profile: 'v1/Profile',
      profileLanguage: 'v1/Profile/language',
      profilePasswordChangeCode: 'v1/Profile/password-change-code',
      profileChangePassword: 'v1/Profile/changePassword',
      profileEmailChangeCode: 'v1/Profile/email-change-code',
      profileChangeEmail: 'v1/Profile/changeEmail',
      profileConfirmDelete: 'v1/Profile/confirm-delete',
      profileDelete: 'v1/Profile/delete',
      twoFactorLoginEmailCode: 'v1/TwoFactor/login/email-code',
      twoFactorLoginVerify: 'v1/TwoFactor/login/verify',
      twoFactorLoginCancel: 'v1/TwoFactor/login/cancel',
      twoFactorStepUpStart: 'v1/TwoFactor/step-up/start',
      twoFactorStepUpEmailCode: 'v1/TwoFactor/step-up/email-code',
      twoFactorStepUpVerify: 'v1/TwoFactor/step-up/verify',
      twoFactorStepUpCancel: 'v1/TwoFactor/step-up/cancel',
      twoFactorEnrollmentStart: 'v1/TwoFactor/enrollment/start',
      twoFactorEnrollmentConfirm: 'v1/TwoFactor/enrollment/confirm',
      twoFactorEnrollmentCancel: 'v1/TwoFactor/enrollment/cancel',
      twoFactorDisable: 'v1/TwoFactor/disable',
    }
  },
  v1: {
    onboarding: 'v1/onboarding',
    household: 'v1/household',
    categories: 'v1/categories',
    transactions: 'v1/transactions',
    recurringIncomeRules: 'v1/recurring-income-rules',
    dashboard: 'v1/dashboard',
    setupStatus: 'v1/setup-status',
    reports: 'v1/reports',
    savingsObjective: 'v1/savings-objective',
    supportedCurrencies: 'v1/supported-currencies',
    gdpr: 'v1/gdpr',
    profileEmail: 'v1/profile/email',
    mobileExpenseReminder: 'v1/profile/mobile-expense-reminder',
  }
};
